import React, { useMemo, useEffect } from 'react';
import { gridTheme } from 'utils/theme';
import i18n from 'utils/i18n';
import { GridThemeProvider } from 'styled-bootstrap-grid';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider } from 'styled-components';
import theme, { mergeThemes } from 'utils/theme';
import { BrowserProvider } from 'components/Contexts';
import { createGlobalStyle } from 'styled-components';
export const GlobalStyle = createGlobalStyle `
  .ReactModalPortal {
    position: relative;
    z-index: 999999;
  }

  .st-modal-backdrop {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    inset: 0px;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    .mapboxgl-map {
      @media screen and (max-width: 680px) {
        .mapboxgl-ctrl-bottom-left {
          top: 16px;
          bottom: auto;
          right: auto;
          left: 8px;
        }
    
        .mapboxgl-ctrl-bottom-right {
          top: 8px;
          right: 8px;
          bottom: auto;
          left: auto;
        }
      }
    }

    .mapboxgl-ctrl button:not(:disabled):hover {
      background-color: rgba(0,0,0,.05) !important;
    }

    .mapboxgl-ctrl button {
      background-color: transparent !important;
      margin: 0 !important;
      min-height: 0 !important;
    }

    .mapboxgl-ctrl-attrib-button {
      background-color: hsla(0,0%,100%,.5) !important;
      padding: 0 !important;
    }
  }
`;
const IntegrationProviderContainer = ({ designSettings, locale, isSafariServerSide, children, }) => {
    const mergedTheme = useMemo(() => mergeThemes(theme, designSettings), [designSettings]);
    useEffect(() => {
        i18n.changeLanguage(locale);
    }, []);
    return (React.createElement(BrowserProvider, { isMobileServerSide: undefined, isSafariServerSide: isSafariServerSide },
        React.createElement(GridThemeProvider, { gridTheme: gridTheme },
            React.createElement(I18nextProvider, { i18n: i18n },
                React.createElement(ThemeProvider, { theme: mergedTheme },
                    React.createElement(GlobalStyle, null),
                    React.createElement("link", { href: "https://api.mapbox.com/mapbox-gl-js/v2.3.1/mapbox-gl.css", rel: "stylesheet" }),
                    children)))));
};
export default IntegrationProviderContainer;
